/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import {  toast } from 'react-toastify';

// components
import Breadcrumbs from "../../components/Breadcrumbs";
import PageHeader from "../../components/pageHeader";
import Filters from "./components/filters";
import ActivitiesTable from "./components/activitiesTable"

// actions
import {
  getUserActivities,
  resetUserActivities,
} from '../../store/reducers/userActivitiesSlice'

// helpers
import { removeEmptyProperties } from "../../helpers/general";

// constants
import { INITIAL_FILTERS } from './userActivities.constants';


//styles

function UserActivities() {
  
  const [isFetching, setIsFetching] = useState(false);
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const dispatch = useDispatch()
  
  const getActivities = async () => {
    setIsFetching(true)
    try {
      if (Object.keys(removeEmptyProperties(filters).length>=1)) {
        const res = await dispatch(getUserActivities(filters)).unwrap()
        if(res.totalRecordsMatched == 0) {
          toast.warning('No Records found.')
        }
      }
    } catch (error) {
      let message = error.message;
      if(error.message.includes('403')) {
        message = 'You are not authorized to perform this action, you need to have Auditor group access';
      }
      dispatch(resetUserActivities())
      toast.error(message)
    } finally {
      setIsFetching(false)
    }
  }

  const breadcrumbStyle = {
    backgroundColor: 'rgb(245, 245, 245)',
    width: '100vw',
    padding: '20px 20px 10px',              
    height: '140px',
  };

  useEffect(() => {
    if (Object.keys(removeEmptyProperties(filters).length>=1)) {
      // dispatch(resetUserActivities())
    }
  }, [filters])

  return (
    <>
      <div style={breadcrumbStyle}>
       <Breadcrumbs value={'Audits / User Activities'} />
      </div>
      {/* <PageHeader title="User Activities" view={true}/> */}
      <Filters filters={filters} setFilters={setFilters} getUserActivities={getActivities} />
      <ActivitiesTable />
    </>
  );
}

export default UserActivities;
